import React from 'react';
import { node } from 'prop-types';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  // componentDidCatch(error, errorInfo) {}

  componentDidUpdate(props) {
    if (props.children !== this.props.children && this.state.hasError) {
      this.reset();
    }
  }

  reset = () => this.setState({ hasError: false });

  render() {
    if (this.state.hasError) {
      console.log('Error: ', this.state.error);
      return '';
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: node.isRequired
};

export default ErrorBoundary;
